import * as THREE from 'three';
import TextMesh from '../../utils/textmesh.js';
import CameraManager from '../../widgets/timeline/cameramanager.js';

export default class Dates {

    constructor(config ={}) {

        let self = this;
        let defaultConfig = {
            dist:800
        }

        // merge config with default
        this.totaldates = Object.keys(timelineData.dates).length;
        this.config = deepmerge(defaultConfig, config);
        this._depth = 0;
        this.datesselector_el = document.querySelector('#TimelineDateSelector .date');

        this.up_el   = document.querySelector('#TimelineDateSelector .up');
        this.down_el = document.querySelector('#TimelineDateSelector .down');

        this._currindex = 0;
        this.arraycurrindex = {value:"",moveFrom:""};


        this.up_el.addEventListener("click", function(){
            self.currindex = self.currindex + 1;
            self.arraycurrindex["value"] = self.currindex;
            self.arraycurrindex["moveFrom"] = "button";

            self.updatecamera();

        });

        this.down_el.addEventListener("click", function(){
            self.currindex = self.currindex - 1;
            self.arraycurrindex["value"] = self.currindex;
            self.arraycurrindex["moveFrom"] = "button";
            self.updatecamera();
        });

        document.addEventListener("camera_event", function (event) {
            self.doCameraEvent(event);
            self.arraycurrindex["moveFrom"] = "";
            // posCam = (window.innerWidth < 600)? posCam + 2000 : posCam + 2200 ;
             self.hideLine((event.detail.data.data)-250);
        });


    }

    doCameraEvent(cam_event){
        let index = Math.ceil(cam_event.detail.data.data/(window.timeline.cameramanager.config.depth / this.totaldates));

        this.arraycurrindex["moveFrom"] = ((this.arraycurrindex["moveFrom"] == "") ? "event" : this.arraycurrindex["moveFrom"]);

        if( index != this.currindex){

            if(this.arraycurrindex["moveFrom"] == "button" ){

                this.arraycurrindex["moveFrom"] = "button";
                this.currindex = this.currindex;
                this.arraycurrindex["value"] = this.currindex;

            }else{
                this.currindex = index;
                this.arraycurrindex["value"] = index;
                this.arraycurrindex["moveFrom"] = "event1";
           }

        }else{
            this.currindex = index;
            this.arraycurrindex["value"] = index;
            this.arraycurrindex["moveFrom"] = "event2";

        }

    }

    updatecamera(){
        window.timeline.cameramanager._targetZ = (window.timeline.cameramanager.config.depth / this.totaldates) * this.currindex;
        window.timeline.cameramanager.scrolling = true;
    }

    get currindex(){
        return this._currindex;
    }

    set currindex(i){

        if(i < 0) i=0;
        if(i > this.totaldates - 1) i=this.totaldates - 1;

        let posY = 100 - ((100 / Object.keys(timelineData.dates).length) * i);
        this.datesselector_el.style.transform = `translateY(-${posY}%)`;

        for(let date_span_el of this.datesselector_el.children){
            if(date_span_el.dataset.index == i){
                date_span_el.classList.add('active');
            } else {
                date_span_el.classList.remove('active');
            }
        }

        this._currindex = i;

    }

    get trackwidth(){
        let w = 4000;
        // if(window.innerWidth < 600) w = 1500;
        // if(window.innerWidth > 600 && window.innerWidth < 1025) w = 3200;

        if(window.innerWidth < 600){
            w = 1600;
        }else if (window.innerWidth > 600 && window.innerWidth < 1025) {
            w = 3200;
        }
        return w;
    }

    get trackcount(){
        return Object.keys(timelineData.events).length;
    }

    makeDates(){

        let line_geom = new THREE.PlaneBufferGeometry(2, this.trackwidth * 1.4, 1, 1);
        let line_material = new THREE.MeshPhongMaterial({
            color: 0xffffff,
            side: THREE.DoubleSide
        });

        this.datesObj = new THREE.Object3D();

        // length tracks
        let i=0;       
        for(let date in timelineData.dates.reverse()){

            this._depth = i * this.config.dist;

            let line = new THREE.Mesh(line_geom, line_material);
            line.name = "line";
            this.datesObj.add(line);

            line.position.z = this._depth;
            line.position.y = (window.innerWidth < 600)?200:5;
            line.rotation.z = Math.PI / 2;

            let text_mesh = new TextMesh(
            {
                message: timelineData.dates[date],
                textColour: '#ffffff',
                textBGColour: "rgba( 233, 129, 127, 0 )",
                scale:1.6
            });

            this.datesObj.add(text_mesh);
            text_mesh.name =  timelineData.dates[date];
            text_mesh.position.z =  this._depth;
            text_mesh.position.y = (window.innerWidth < 600)? 150 :-50;
            text_mesh.position.x = (this.trackwidth * 1.4) / 2;
            text_mesh.rotation.y = Math.PI;

            // set up scrolling date selector
            let date_span_el = document.createElement('span');
            this.datesselector_el.appendChild(date_span_el);

            date_span_el.textContent   = timelineData.dates[date];
            date_span_el.dataset.index = i;

            if(i==0) date_span_el.classList.add('active');

            i++;

        }

        this.datesObj.position.y = 500;
        return this.datesObj;

    }
    
    get depth(){
        return this._depth;
    }

    update(){

    }

    hideLine(posCam){
        for(let i = 0 ; i <  this.datesObj.children.length ;i++){
            if( this.datesObj.children[i].name == "line"){
                this.datesObj.children[i].position.y = ( posCam > (this.datesObj.children[i].position.z - 250))? -100000 : 5;
            }

        }
    }


}



